import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=0a8d49d5&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports